import { unconvertBigNumber } from "../../pages/transactions/overview/table/regexes";
import Amount from "./Amount";
class Denominations {
    minimum;
    multiple;
    constructor(response) {
        this.minimum = response.minimum !== undefined ? new Amount(response.minimum) : undefined;
        this.multiple = response.multiple !== undefined ? new Amount(response.multiple) : undefined;
    }
    print(globalCurrency) {
        if (this.minimum !== undefined) {
            const text = [];
            const currency = this.minimum.currency ?? this.multiple?.currency ?? globalCurrency;
            if (currency !== undefined) {
                text.push(currency);
            }
            if (this.minimum.value !== undefined) {
                const t = unconvertBigNumber(this.minimum.value);
                text.push(t);
            }
            if (this.multiple?.value !== undefined) {
                const m = unconvertBigNumber(this.multiple.value);
                text.push("+" + m);
            }
            return text.join(" ");
        }
    }
    printNoCurrency() {
        if (this.minimum !== undefined) {
            const text = [];
            if (this.minimum.value !== undefined) {
                const t = unconvertBigNumber(this.minimum.value);
                text.push(t);
            }
            if (this.multiple?.value !== undefined) {
                const m = unconvertBigNumber(this.multiple.value);
                text.push("x");
                text.push(m);
            }
            return text.join(" ");
        }
    }
}
export default Denominations;
